<template>
    <base-dialog
        v-model="isModalOpen"
        :min-width="900"
        :max-width="900"
        :on-close="closeModal"
        :on-cancel="closeModal"
        :on-save="disconnectProject">
        <template #title>
            <p class="font-weight-regular text-h4 ma-0">
                {{ $t('privateConnect.disconnectProjectTitle', { connectionName }) }}
            </p>
        </template>
        <template #body>
            <div class="pt-6">
                {{
                    $t('privateConnect.disconnectProjectDescription')
                }}
            </div>
        </template>
        <template #actions="{ cancel, save }">
            <v-spacer />
            <v-btn
                color="primary"
                depressed
                rounded
                outlined
                class="cancel"
                @click="cancel">
                <span class="text-none">{{ $t('cancel') }} </span>
            </v-btn>
            <v-btn
                color="error"
                depressed
                rounded
                @click="save">
                <span class="text-none"> {{ $t("disconnect") }}</span>
            </v-btn>
        </template>
    </base-dialog>
</template>
<script>
    export default {
        name: 'DisconnectPrivateConnectModal',
        props: {
            connectionName: {
                type: String,
                required: true,
            },
            openDialog: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isModalOpen: this.openDialog,
            }
        },
        watch: {
            openDialog(val) {
                this.isModalOpen = val
            },
        },
        methods: {
            closeModal() {
                this.$emit('on-close-modal')
            },
            disconnectProject() {
                this.$emit('on-confirm-disconnect')
            },
        },
    }
</script>
